import { FirmMember, User } from '../generated/graphql';

export const findFirmMemberForSelf = (firmMembers: FirmMember[], self?: User | null) =>
  firmMembers.find((firmMember) => firmMember.userID === self?.id);
